import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { typography } from '@landsbankinn/ui';
import React from 'react';
import { animated } from 'react-spring';
import res from './MobileNav.res';

const Host = styled.div`
  margin-top: 10%;
`;

const OnlinebankItem = styled(animated.a)`
  ${typography.h4};
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(29, 61, 90, 0.1);
  cursor: pointer;
  position: relative;
  display: block;

  &:not(:first-child) {
    margin-top: 17px;
  }
`;

export function OnlinebankLinks() {
  const { r, locale } = useResource();
  return (
    <Host>
      <OnlinebankItem
        key={'onlinebank-personal'}
        href={locale === 'is' ? '/en' : '/'}
      >
        {r(res.language)}
      </OnlinebankItem>
    </Host>
  );
}
